import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

// The vocabulary the valuation engine prices on, plus `unknown`.
//
// NOTE there are two definitions of this list: this codec, which gates what can be
// written to `listings.condition`, and `domain/models/ListingCondition1.ts`, which
// carries the display names and the selectable subset. They have to agree — this one
// decides what saves, that one decides what a valuer sees.
//
// The last three are SUPERSEDED. They stay because rows still hold them and a codec
// that stops accepting a stored value is an outage (the roadblock literal rename
// #3447, and the PIF strict codec, both did exactly that). They are absent from
// `selectableValues` in the models file, so nothing new can be filed under them.
export const ListingCondition1 = union([
    literal("unknown"),
    literal("excellent"),
    literal("good"),
    literal("average"),
    literal("poor"),
    literal("refurb_required"),
    literal("major_renovation_required"),

    literal("good_benefit_from_refurbishment"),
    literal("poor_liveable_but_requires_work"),
    literal("poor_not_immediately_liveable"),
]);
